"use client";

import { Info } from "@suite/components/icons";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface Props {
  text: string;
}

/** Small inline "what does this mean" affordance for a technical label — the dark-fixed tool
 * panels sit outside the site's normal theme, but the shared Tooltip's tokens (--foreground /
 * --background) are re-pinned by that same `.dark-fixed` wrapper, so it renders correctly here
 * without a suite-local fork. */
export default function InfoTooltip({ text }: Props) {
  return (
    <TooltipProvider delay={200} closeDelay={0}>
      <Tooltip>
        <TooltipTrigger
          aria-label="What this means"
          className="focus-visible:ring-brand-green/70 inline-flex size-3.5 shrink-0 items-center justify-center rounded-full text-white/40 transition-colors outline-none hover:text-white/70 focus-visible:ring-2"
        >
          <Info className="size-3" aria-hidden />
        </TooltipTrigger>
        <TooltipContent className="max-w-64 text-xs leading-relaxed" sideOffset={6}>
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
